import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './ProjectsComponent.metadata.json5';

import TypesofProjectsComponent from '../subcomponents/TypesofProjects/TypesofProjectsComponent'
import PastProjectTableComponent from '../subcomponents/PastProjectTable/PastProjectTableComponent'
import PastDesignandBuildingProjectsComponent from '../subcomponents/PastDesignandBuildingProjects/PastDesignandBuildingProjectsComponent'
import styles from '../ArchitectEngineer.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function ProjectsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ProjectsComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        typesofProjectsComponent: {
            data: modelVM.typesofProjectsDTO,
            updateWizardData,
            submissionVM,
            TypesofProjectsPath: `${pathUpdated}.typesofProjectsDTO`
        },
        speWhaTypOfProOthRef3: {
            required: modelVM.value.typesofProjectsDTO[0].oth6 > 0,
            visible: modelVM.value.typesofProjectsDTO[0].oth6 > 0
        },
        pastProjectTableComponent: {
            data: modelVM.pastProjectTableDTO,
            updateWizardData,
            submissionVM,
            PastProjectTablePath: `${pathUpdated}.pastProjectTableDTO`
        },
        pastDesignandBuildingProjectsComponent: {
            data: modelVM.pastDesignandBuildingProjectsDTO,
            updateWizardData,
            submissionVM,
            PastDesignandBuildingProjectsPath: `${pathUpdated}.pastDesignandBuildingProjectsDTO`
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            typesofProjectsComponent: TypesofProjectsComponent,
            pastProjectTableComponent: PastProjectTableComponent,
            pastDesignandBuildingProjectsComponent: PastDesignandBuildingProjectsComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ProjectsComponent.propTypes = wizardProps;
export default withRouter(ProjectsComponent);
